<template>
    <form class="kt-form" @submit.prevent="submit($event)" id="submit-form" v-if="status==='success'">
        <kt-form-section>
            <kt-form-row>
                <kt-col lg="12" md="12" sm="12">
                    <kt-form-group>
                        <kt-form-label>
                            {{$t('label.question')}}
                        </kt-form-label>
                        <ckeditor :editor="editor"
                                  v-model="questionForm.question"
                                  :config="editorConfig"
                                  tag-name="textarea"
                        >
                        </ckeditor>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="12" md="12" sm="12">
                    <kt-form-group>
                        <kt-form-label>
                            {{$t('label.answer')}}
                        </kt-form-label>
                        <ckeditor :editor="editor"
                                  v-model="questionForm.answer"
                                  :config="editorConfig"
                                  tag-name="textarea"
                        >
                        </ckeditor>
                    </kt-form-group>
                </kt-col>
            </kt-form-row>
        </kt-form-section>
        <kt-form-action>
            <button
                class="btn btn-success btn-wide"
                type="submit"
                id="submit-btn"
            >
                {{ $t('btn.submit') }}
            </button>
        </kt-form-action>
    </form>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {editorConfig} from '@/constants/ckeditorConfigs'
import {mapGetters} from "vuex";

export default {
    props: {
        submit: {
            default: () => {
                return {}
            },
            type: Function
        },
    },
    components: {
        ckeditor: CKEditor.component
    },
    data() {
        return {
            data: null,
            editor: ClassicEditor,
            editorData: '',
            editorConfig: editorConfig,
        }
    },
    computed: {
        ...mapGetters('FAQ', [
            'status',
            'questionForm'
        ])
    }
}
</script>

<style>
.ck-editor__editable {
    min-height: 100px !important;
}
</style>